var id = 0;
var ua = function () { return navigator.userAgent; };
export var generateCallbackName = function (prefix) {
    if (prefix === void 0) { prefix = ''; }
    var callbackName = prefix + "_" + Date.now() + "_" + id++;
    for (var i = 0; i < 500 && window[callbackName]; i++) {
        callbackName = prefix + "_" + Date.now() + "_" + id++;
    }
    if (window[callbackName]) {
        throw new Error(prefix + "_\u56DE\u8C03\u65B9\u6CD5\u91CD\u590D");
    }
    return callbackName;
};
export var isIOS = function () {
    return /iP(hone|od|ad)/.test(ua());
};
export var isMobile = function () {
    return /iPad|iPhone|iPod|Android|Mobile/.test(ua());
};
export var base64ToString = function (b64) {
    b64 = String(b64)
        .replace(/[-_]/g, function (m0) { return m0 === '-' ? '+' : '/'; })
        .replace(/[^A-Za-z0-9+/]/g, '');
    return (new Buffer(b64, 'base64')).toString();
};
export var isDartWebView = function () {
    return /bridgetype\/2/.test(ua());
};
